import { Box, Text, Flex } from "@chakra-ui/react";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { hideToast } from "../../redux/reducer/utilsSlice";
import { colors } from "../../theme";
import { CloseIcon, CheckIcon } from "../../utils/svg";

/**
 * Toast - Global toast notification component
 * Displays messages from Redux utils state
 */
const Toast = () => {
  const dispatch = useDispatch();
  const { visible, message, type } = useSelector((state) => state.utils);

  // Each message gets its own 4 seconds (a second message used to inherit
  // the first one's timer and could vanish at once).
  useEffect(() => {
    if (visible) {
      const timer = setTimeout(() => {
        dispatch(hideToast());
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [visible, message, dispatch]);

  if (!visible || !message) return null;

  const isError = type ? type === "error" :
                  message.toLowerCase().includes("error") || 
                  message.toLowerCase().includes("failed") ||
                  message.toLowerCase().includes("expired") ||
                  message.toLowerCase().includes("unauthorized");

  return (
    <Box
      position="fixed"
      bottom={6}
      right={6}
      zIndex={9999}
      maxW="400px"
      animation="slideIn 0.3s ease"
    >
      <Flex
        bg={isError ? "#FEE2E2" : "#DCFCE7"}
        border="1px solid"
        borderColor={isError ? "#EF4444" : "#22C55E"}
        borderRadius="md"
        p={4}
        align="flex-start"
        gap={3}
        boxShadow="lg"
      >
        <Flex
          w={6}
          h={6}
          borderRadius="full"
          bg={isError ? "#EF4444" : "#22C55E"}
          align="center"
          justify="center"
          flexShrink={0}
        >
          {isError ? (
            <CloseIcon boxSize={3} color="white" />
          ) : (
            <CheckIcon boxSize={3} color="white" />
          )}
        </Flex>
        <Box flex={1}>
          <Text
            fontSize="sm"
            fontWeight="500"
            color={isError ? "#991B1B" : "#166534"}
          >
            {message}
          </Text>
        </Box>
        <Box
          as="button"
          onClick={() => dispatch(hideToast())}
          p={1}
          borderRadius="sm"
          _hover={{ bg: isError ? "#FECACA" : "#BBF7D0" }}
        >
          <CloseIcon boxSize={4} color={isError ? "#991B1B" : "#166534"} />
        </Box>
      </Flex>
    </Box>
  );
};

export default Toast;
